import { useEffect, useRef, useCallback } from "react";
import { io } from "socket.io-client";
import { IS_DEV } from "./api";

export const useSocket = (token) => {
  const socketRef = useRef(null);
  const isConnected = useRef(false);

  const connect = useCallback(() => {
    if (!token || socketRef.current?.connected) return;

    socketRef.current = io(
      IS_DEV ? "ws://localhost:2000" : "wss://api.beatai.io",
      {
        path: "/socket.io/",
        transports: ["websocket"],
        auth: { token },
      }
    );

    socketRef.current.on("connect", () => {
      console.log("Connected to WebSocket server");
      isConnected.current = true;
    });

    socketRef.current.on("connect_error", (error) => {
      console.error("Connection error:", error);
      isConnected.current = false;
    });

    socketRef.current.on("disconnect", () => {
      isConnected.current = false;
    });
  }, [token]);

  const disconnect = useCallback(() => {
    if (socketRef.current) {
      socketRef.current.disconnect();
      socketRef.current = null;
      isConnected.current = false;
    }
  }, []);

  const emit = useCallback((event, data) => {
    if (socketRef.current?.connected) {
      socketRef.current.emit(event, data);
    }
  }, []);

  const subscribe = useCallback((event, callback) => {
    socketRef.current?.on(event, callback);
  }, []);

  const unsubscribe = useCallback((event, callback) => {
    socketRef.current?.off(event, callback);
  }, []);

  useEffect(() => {
    connect();
    return () => disconnect();
  }, [connect, disconnect]);

  return {
    isConnected: isConnected.current,
    emit,
    subscribe,
    unsubscribe,
  };
};
